import { Box, Text, VStack } from '@chakra-ui/react'
import { EncounterType } from '@hb/shared'
import { ReactNode } from 'react'
import { useProfile } from '../../contexts/user/ProfileContext'
import { ExamListGroupProvider } from './context'
import { EncounterForm } from './EncounterForm'
import { EncounterListGroupHeader } from './EncounterListGroupHeader'
import { ProfileEncounterList } from './EncountersList/ProfileEncountersList'
import { EncounterView } from './EncounterView'
import { useEncounterOpenState } from './useEncounterOpenState'

export const GynProfileEncounters = () => {
  const { userId } = useProfile()
  // §1.6 / M.2: status-driven routing between the read-only view and the form,
  // including the Amend flow's reason plumbing (§1.6.1).
  const {
    selection: openEncounter,
    surface,
    open: setOpenEncounter,
    onEdit,
    onSaveSuccess,
    amendmentReason,
    onAmendmentReasonConsumed,
  } = useEncounterOpenState()

  if (!userId) {
    return (
      <Box w="100%" overflowY="auto" p={4} h="100%">
        <Text>No patient selected</Text>
      </Box>
    )
  }
  let body: ReactNode = null
  if (openEncounter) {
    body =
      surface === 'view' && openEncounter.examId ? (
        <EncounterView
          patientId={userId}
          examId={openEncounter.examId}
          onClose={() => setOpenEncounter(null)}
          onEdit={onEdit}
        />
      ) : (
        <EncounterForm
          patientId={userId}
          openEncounter={openEncounter}
          amendmentReason={amendmentReason}
          onAmendmentReasonConsumed={onAmendmentReasonConsumed}
          onClose={() => setOpenEncounter(null)}
          onSuccess={onSaveSuccess}
        />
      )
  } else {
    body = (
      <Box w="100%" overflowY="auto" p={4} bg="#efefef" h="100%">
        <VStack w="100%" spacing={4}>
          <EncounterListGroupHeader title="GYN Care - Encounters" />
          <ProfileEncounterList type={EncounterType.PHYSICAL} onOpenExam={setOpenEncounter} />
          <ProfileEncounterList type={EncounterType.WELL_WOMAN} onOpenExam={setOpenEncounter} />
          <ProfileEncounterList type={EncounterType.ENCOUNTER} onOpenExam={setOpenEncounter} />
        </VStack>
      </Box>
    )
  }

  return <ExamListGroupProvider patientId={userId}>{body}</ExamListGroupProvider>
}
